import { Cell, VariableCell, VariableDefinition } from '@/explore/types';

export const ensureUniqueVariableKey = (cell: VariableCell, cells: Cell[]): VariableCell => {
  return {
    ...cell,
    definition: {
      ...cell.definition,
      key: generateUniqueVariableKey(
        cell.definition.key,
        cells.filter((i) => i.kind === 'variable').map((i) => i.definition.key),
      ),
    },
  };
};

const updateVariableKey = (input: string): string => {
  const match = input.match(/(\d+)$/);

  if (match !== null) {
    return input.slice(0, match.index) + (parseInt(match[1], 10) + 1);
  }

  return `${input} 2`;
};

export const generateUniqueVariableKey = (input: string, keys: string[]): string => {
  let result = input;

  while (keys.includes(result)) {
    result = updateVariableKey(result);
  }

  return result;
};

export type VariableValueType = 'String' | 'Number' | 'Date' | 'Boolean' | 'Array';

export function setVariableCellDefinition(
  cell: VariableCell,
  definition: VariableDefinition,
): VariableCell {
  return { ...cell, definition };
}
